<template>
  <div>
    <Notification :notify="notify" />
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">
          Upload CSV
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">
          Preview
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">
          Summary
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="pl-5 pr-5">
            <v-form ref="form" v-model="valid" lazy-validation>
              <h1>Bulk Users upload</h1>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <a href="/static/templates/BulkUser.csv">Download</a>
                  and fill in the bulk upload CSV user template to help you
                  successfully create users in bulk
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-list flat>
                    <v-subheader>Required Fields</v-subheader>
                    <ul style="list-style-type: none">
                      <li v-for="(item, i) in requiredFields" :key="i">
                        <v-icon v-text="item.icon" small></v-icon>
                        <span>{{ item.text }}</span>
                      </li>
                    </ul>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <span>Upload the CSV file to create users in bulk</span>
                  <v-file-input
                    id="fileupload"
                    :rules="rules"
                    accept=".csv"
                    placeholder="Upload an csv file"
                    prepend-icon="mdi-file-excel"
                    label="File"
                    @change="fileUploadchange"
                    @click:clear="fileClear"
                  ></v-file-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="float-right">
                    <v-btn color="primary" @click="uploadFile" id="btnFileUpload">
                      Continue
                    </v-btn>

                    <v-btn text @click="OnCancel" id="btnCancel">
                      Cancel
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card class="pl-5 pr-5">
            <v-row>
              <v-col>
                <v-data-table
                  :headers="bulkUsers_headers"
                  :items="bulkUsers_mock"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  hide-default-footer
                  class="elevation-1"
                >
                  <template v-slot:item.Message="props">
                    <span
                      v-if="
                        props.item.Message != null &&
                          props.item.Message.length > 0
                      "
                      style="color:red"
                    >
                      {{ props.item.Message }}
                    </span>
                  </template>
                </v-data-table>
                <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn color="primary" @click="uploadblulkUsers" id="btnUulkUploadUser">
                  Create Users
                </v-btn>
                <v-btn text @click="OnGoToSelectUpload" id="btnBack">
                  Back
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card class="pl-5 pr-5">
            <v-alert dense text type="success" v-if="SuccessMessage != null">
              {{ SuccessMessage }}
            </v-alert>
            <v-data-table
              v-if="SuccessMessage != null"
              :headers="bulkUsers_headers"
              :items="bulkUsers_mock"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:item.Message="props"> </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
            <div class="float-right">
              <v-btn text @click="OnCancel" id="btnCancel">
                Clsoe
              </v-btn>
            </div>
            <!-- <Notification :notify="notify" /> -->
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import UserDevice from "@/components/UserDevice";
import * as api from "@/api";
import fileUploadService from "@/api/fileUploadService";
import Notification from "@/components/Notification";
import moment from "moment";
import lodash from "lodash";

export default {
  components: {
    Notification
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      
      itemsPerPage: 10,
      notify: {
        type: 0,
        message: "",
        errors: []
      },
      overlay: false,
      e1: 1,
      bulkUsers_headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "Message"
        },
        {
          text: "FirstName",
          align: "start",
          sortable: false,
          value: "FirstName"
        },
        {
          text: "LastName",
          align: "start",
          sortable: false,
          value: "LastName"
        },
        {
          text: "Email",
          align: "start",
          sortable: false,
          value: "Email"
        },
        {
          text: "Phone",
          align: "start",
          sortable: false,
          value: "Phone"
        },
        {
          text: "Password",
          align: "start",
          sortable: false,
          value: "Password"
        },
        {
          text: "PasswordHint",
          align: "start",
          sortable: false,
          value: "PasswordHint"
        }
      ],
      bulkUsers_mock: [],
      uploadContent: null,
      rules: [
        value => value || "Required.",
        value =>
          !value ||
          value.size < 1000000 ||
          "File size should be less than 1 MB!"
      ],
      valid: true,
      expanded: [],
      SuccessMessage: null,
      requiredFields: [
        { text: "First Name", icon: "mdi-star" },
        { text: "Last Name", icon: "mdi-star" },
        { text: "Email", icon: "mdi-star" },
        { text: "Phone", icon: "mdi-star" },
        { text: "Password", icon: "mdi-star" },
        { text: "Password Hint", icon: "mdi-star" }
      ]
    };
  },
  methods: {
    uploadFile() {
      let that = this;
      this.$refs.form.validate();
      if (
        this.valid &&
        this.uploadContent != null &&
        this.uploadContent.length > 0
      ) {
        that.e1 = 2;
      }
    },
    fileUploadchange: async function(files) {
      let that = this;
      that.bulkUsers_mock.splice(0, that.bulkUsers_mock.length);
      let content = await fileUploadService.uploadFileReader(files);
      this.uploadContent = await fileUploadService.csvStringtoJson(content);
      if (this.uploadContent != null && this.uploadContent.length > 0) {
        debugger;
        this.uploadContent.forEach(e => {
          that.bulkUsers_mock.push({
            FirstName: e.FirstName,
            LastName: e.LastName,
            Email: e.Email,
            FullName: e.FullName,
            Gender: e.Gender,
            Address1: e.Address1,
            Address2: e.Address2,
            City: e.City,
            State: e.State,
            Zip: e.Zip,
            Phone: e.Phone,
            Password: e.Password,
            PasswordHint: e.PasswordHint,
            Message: ""
          });
        });
      }
      console.log(this.uploadContent);
    },
    uploadblulkUsers() {
      let that = this;
      let noOfUsersCreated = 0;
      let tempContent = lodash.cloneDeep(that.bulkUsers_mock);
      this.$refs.form.validate();
      if (
        this.valid &&
        this.bulkUsers_mock != null &&
        this.bulkUsers_mock.length > 0
      ) {
        that.overlay = true;
        let userUploadRequest = {
          values: 0,
          bulkData: []
        };
        this.bulkUsers_mock.forEach(e => {
          userUploadRequest.bulkData.push({
            firstName: e.FirstName,
            lastName: e.LastName,
            gender: e.Gender,
            address1: e.Address1,
            address2: e.Address2,
            city: e.City,
            state: e.State,
            zip: e.Zip,
            phone: e.Phone,
            email: e.Email,
            password: e.Password,
            passwordhint: e.PasswordHint,
            Country: "string"
          });
        });
        //----------------------------------
        new Promise((resolve, reject) => {
          api
            .bulUpdate("user/Upload", userUploadRequest)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                if (response.data != null && response.data.length > 0) {
                  for (let i = 0; i < response.data.length; i++) {
                    if (
                      response.data[i].ValidationMessage != undefined &&
                      response.data[i].ValidationMessage != null &&
                      response.data[i].ValidationMessage.length > 0
                    ) {
                      let messages = lodash.map(
                        response.data[i].ValidationMessage,
                        function(e) {
                          return lodash.capitalize(e.Message);
                        }
                      );
                      that.bulkUsers_mock[i].Message = messages.join(", ");
                    } else if (
                      response.data[i].organization != undefined ||
                      (response.data[i].organization != null &&
                        response.data[i].organization.id != null)
                    ) {
                      noOfUsersCreated++;
                    }
                  }
                }
                console.log("Update Errors");
                console.log(that.bulkUsers_mock);
                if (
                  noOfUsersCreated > 0 &&
                  noOfUsersCreated == userUploadRequest.bulkData.length
                ) {
                  that.notify.type = 1;
                  this.notify.message = "Successfully created.";
                  that.SuccessMessage =
                    "User accounts has been created successfully!";
                  setTimeout(() => {
                    that.notify.type = 0;
                  }, 3000);
                  that.e1 = 3;
                }
              } else {
                that.notify.type = 4;
                that.notify.errors.push("Failed to save data.");
              }
            })
            .catch(error => {
              console.log("API Error");
              console.log(error);
              that.notify.type = 4;
              that.notify.errors = [];
              if (error.data != null && error.data.message != null) {
                that.notify.errors.push(
                  "Failed to save data. " + error.data.message
                );
              } else {
                that.notify.errors.push("Failed to save data. " + error);
              }
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
              return false;
              reject(error);
            });
        });
        //----------------------------------
        that.e1 = 2;
        that.overlay = false;
      }
    },
    OnCancel() {
      this.$router.push("/dashboard");
    },
    OnGoToSelectUpload() {
      this.e1 = 1;
    },
    fileClear() {
      let that = this;
      that.bulkUsers_mock.splice(0, that.bulkUsers_mock.length);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Organization/OrgBulkUsers.vue